// Assign (or clear) the measurement unit for one or more signals
// (POST /signal/units/assign).
const action = "SIGNAL_ASSIGN_UNIT";
export const REQUEST = action + '_REQUEST';
export const RESPONSE = action + '_RESPONSE';
export const FAILURE = action + '_FAILURE';
export const CLEAR = action + '_CLEAR';

// payload: { keys: [...], unit } — empty unit clears the assignment.
export const fetchRequest = (payload) => ({ type: REQUEST, payload });
export const fetchSuccess = (response) => ({ type: RESPONSE, payload: response });
export const fetchFailure = (error) => ({ type: FAILURE, payload: error });
export const clearState = () => ({ type: CLEAR });
